import React, { useContext } from 'react';
import styled, { css } from 'styled-components';
import { Avatar } from '@ubeya/shared-web/components/Avatar';
import Tooltip from '@ubeya/shared-web/components/Tooltip/Tooltip';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const AvatarWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

const BranchName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;

  ${({ $truncate }) =>
    $truncate &&
    css`
      max-width: 140px;
    `}
  line-height: 20px;
  font-size: 12px;
`;

const BranchDisplay = ({ branch, compact = false, truncate = false }) => {
  const { isShowLastNameFirst = false } = useContext(ConfigContext);

  if (!branch?.name) {
    return null;
  }

  const { name, logo } = branch;
  const [first, second] = isShowLastNameFirst ? [name.charAt(1), name.charAt(0)] : [name.charAt(0), name.charAt(1)];

  return (
    <Tooltip body={name}>
      <Wrapper>
        <AvatarWrap>
          <Avatar firstName={first} lastName={second} image={logo} size="xs" />
        </AvatarWrap>
        {!compact && <BranchName $truncate={truncate}>{name}</BranchName>}
      </Wrapper>
    </Tooltip>
  );
};

export default BranchDisplay;
